import { generatePath } from 'react-router-dom';
import { Button } from '@accure/ui/components/button/button-catalyst';
import { addDays } from 'date-fns';

import { useCurrentAsset } from '@/hooks/use-current-asset';
import { formatDate } from '@/utils/format/date';

export type ButtonDataExplorerProps = {
  startDate: Date | undefined;
  endDate: Date | undefined;
};

export function ButtonDataExplorer({
  startDate,
  endDate,
}: ButtonDataExplorerProps) {
  const { assetId } = useCurrentAsset();

  if (!assetId) {
    return null;
  }

  const pathDataExplorer = generatePath('/asset/:siteId/data-explorer', {
    siteId: assetId,
  });

  const from = startDate ?? (endDate ? addDays(endDate, -1) : undefined);
  let to = endDate ?? (startDate ? addDays(startDate, 1) : undefined);

  // If the time range is less than 24 hours, extend the end date by 1 day
  if (from && to) {
    const diffInMs = to.getTime() - from.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    if (diffInHours < 24) {
      to = addDays(to, 1);
    }
  }

  return (
    <Button
      plain
      to={{
        pathname: pathDataExplorer,
        search: new URLSearchParams({
          from: from ? formatDate(from) : '',
          to: to ? formatDate(to) : '',
        }).toString(),
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      View Data Explorer
    </Button>
  );
}
